<nav class="navbar navbar-expand-sm bg-light navbar-light">
    <div class="container">
       <a class="navbar-brand" href="#"><img src="assets/images/2.svg" 
          style="height:30px"></a>
       <ul class="nav navbar-nav navbar-right">
          <li class="nav-item">
             <a class="nav-link" href="#"><button type="button" id="btn" 
                class="btn btn-default">Login</button></a>
          </li>
       </ul>
    </div>
 </nav>
 <section class="container mt-5">
    <div class="row">
       <div class="col-md-8">
          <h4 id="h4">6 nights to Barcelona</h4>
          <ul class="nav" style="margin-top: 30px;">
             <li class="nav-item" id="nav-item">
                <a href="#"><i class="fa fa-medkit" id="med"></i><br/>
                <span id="span">DAY WISE PLAN</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"> <span id="span1">+</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"><i class="fas fa-plane" id="med"></i><br/>
                <span id="span">FLIGHT</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"> <span id="span1">+</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"><i class="fas fa-door-closed" id="med"></i><br/>
                <span id="span">STAY</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"> <span id="span1">+</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"><i class="fas fa-car-alt" id="med"></i><br/>
                <span id="span">TRANSFER</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"> <span id="span1">+</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"><i class="fas fa-film" id="med"></i><br/>
                <span id="span">ACTIVITY</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#"> <span id="span1">+</span></a>
             </li>
             <li class="nav-item" id="nav-item">
                <a href="#" data-toggle="modal" data-target="#myModal">
                <i class="fa fa-circle" id="med1"></i>
                <i class="fa fa-circle"  id="med1"></i>
                <i class="fa fa-circle"  id="med1"></i><br/>
                <span id="span">MORE</span></a>
             </li>
          </ul>
          <div class="modal fade" id="myModal">
             <div class="modal-dialog modal-lg">
                <div class="modal-content">
                   <div class="modal-body" style="padding: 0rem;">
                      <div class="container-fluid">
                         <div class="row">
                            <div class="col-md-5">
                                <div class="bg"></div>
                                <p id="par1">We will get the best prices for your<br/>
                                Europe trip from our trusted travel<br/> partners. </p>
                                <ul id="par2" class="nav">
                                    <li class="nav-item" id="nav-item">
                                       <a href="#"><i class="fas fa-plane" id="med2"></i><br/>
                                        <span id="span12">8415</span><br/>
                                       <span id="span11">flights</span></a>
                                    </li>
                                    <li class="nav-item" id="nav-item">
                                        <a href="#"><i class="fas fa-band-aid" id="med2"></i><br/>
                                        <span id="span12">15K</span><br/>
                                        <span id="span11">activities</span></a>
                                     </li>
                                    <li class="nav-item" id="nav-item">
                                       <a href="#"><i class="fas fa-hotel" id="med2"></i><br/>
                                        <span id="span12">18K</span><br/>
                                        <span id="span11">hotels</span></a>
                                    </li>
                                    <li class="nav-item" id="nav-item">
                                       <a href="#"><i class="fas fa-car" id="med2"></i><br/>
                                        <span id="span12">4283</span><br/>
                                       <span id="span11">transfer</span></a>
                                    </li>
                                 </ul>
                            </div>
                            <div class="col-md-7">
                                <button type="button" class="close" style="margin-top: 10px;"
                                 data-dismiss="modal">&times;</button>
                               <div>
                                  <h5 id="h51">What is your travel plan like?</h5>
                               </div>
                               <form>
                                  <div class="form-group">
                                     <label>Departing from:</label>
                                     <input type="text" class="form-control" placeholder="....">
                                  </div>
                                  <div class="form-group">
                                     <label>Arrival On:</label>
                                     <input type="date" class="form-control" placeholder="....">
                                  </div>
                                  <div class="form-group" style="padding: 10px;">
                                     <label>Travelling as</label><br/>
                                     <button type="button" id="btn2" class="btn">
                                     ❤️Couple</button>
                                     <button type="button" id="btn2" class="btn">
                                     👪Family</button>
                                     <button type="button" id="btn2" class="btn">
                                     🎉Friends</button>
                                     <button type="button" id="btn2" class="btn">
                                     😎Solo</button>
                                  </div>
                                  <div class="form-group" style="margin-top: 15rem;">
                                    <button type="button" id="btn3" class="btn btn-light btn-lg btn-block">
                                        Get Cost</button>
                                  </div>
                               </form>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
          </div>
          <div>
             <table class="table table-bordered" id="table">
                <thead>
                   <tr>
                      <th colspan="4" class="table-secondary">Barcelona — 
                         <span id="span3">6 nights stay</span> 
                         <span id="span2">View Guide</span>
                      </th>
                   </tr>
                </thead>
                <tbody>
                   <tr>
                      <td>Day 01</td>
                      <td colspan="3">
                         <img src="assets/images/12.jpg"
                            style="width: 40px;height: 40px;border-radius: 50%;" >
                         <span id="span4">FULL DAY</span>
                         <p id="span5">Arrive in Barcelona airport. Get transferred
                            to your hotel..
                         </p>
                      </td>
                   </tr>
                   <tr>
                      <td>Day 02</td>
                      <td>
                         <img src="assets/images/12.jpg"
                            style="width: 40px;height: 40px;border-radius: 50%;" >
                         <span id="span4">MORNING </span>
                         <p id="span6">Columbus Monument Ticket with Upgrade Wine 
                            Tasting in Barcelona.
                         </p>
                      </td>
                      <td>
                         <span id="span4">Noon</span>
                         <p id="span7">At leisure. <span id="span8">
                            Add activity +
                            </span>  
                         </p>
                      </td>
                      <td >
                         <img src="assets/images/12.jpg"
                            style="width: 40px;height: 40px;border-radius: 50%;" >
                         <span id="span4">FULL DAY</span>
                         <p id="span6">Arrive in Barcelona airport. Get transferred
                            to your hotel..
                         </p>
                      </td>
                   </tr>
                   <tr>
                      <td>Day 03</td>
                      <td>
                         <img src="assets/images/12.jpg"
                            style="width: 40px;height: 40px;border-radius: 50%;" >
                         <span id="span4">MORNING </span>
                         <p id="span6">Banana Boat Experience..</p>
                      </td>
                      <td colspan="2">
                         <span id="span4">Noon</span>
                         <p id="span7">At leisure. <span id="span8">
                            Add activity +</span> 
                         </p>
                      </td>
                   </tr>
                   <tr>
                      <td>Day 04</td>
                      <td colspan="3">
                         <img src="assets/images/12.jpg"
                            style="width: 40px;height: 40px;border-radius: 50%;" >
                         <span id="span4">FULL DAY</span>
                         <p id="span5">Arrive in Barcelona airport. Get transferred
                            to your hotel..
                         </p>
                      </td>
                   </tr>
                   <tr>
                      <td>Day 05</td>
                      <td colspan="2">
                         <img src="assets/images/12.jpg"
                            style="width: 40px;height: 40px;border-radius: 50%;" >
                         <span id="span4">FULL DAY</span>
                         <p id="span9">Arrive in Barcelona airport. Get transferred
                            to..
                         </p>
                      </td>
                      <td>
                         <span id="span4">Noon</span>
                         <p id="span7">At leisure. <span id="span8">
                            Add activity +</span> 
                         </p>
                      </td>
                   </tr>
                </tbody>
             </table>
          </div>
       </div>
       <div class="col-md-4">
          <div class="box">
             <h6 id="h6"><i class="fas fa-edit"></i>&nbsp;Enter Travel details</h6>
             <hr/>
             <div style="text-align: center;">
                <button type="button" id="btn1">Get trip cost</button>
             </div>
          </div>
          <div class="box1">
             <div class="clearfix">
                <img src="assets/images/13.jpeg" class="float-left" style="width: 90px;
                   padding: 10px;">
                <p id="par">Whatsapp Sanjay <br/><span id="span10">
                   Planned 457+ trips so far</span>
                   <i class='fas fa-angle-right' id="arr"></i>
                </p>
             </div>
          </div>
          
       </div>
    </div>
 </section>